<template>
  <div
    class="Fuell-Table--row"
    :class="{ 'regular-user': isUser, 'no-event': transactionIsAuthorization || transactionIsDeclined }"
    :style="tableGridTemplateStyle"
  >
    <template v-for="column in columns">
      <div
        v-if="showSelect && column.key === COLUMNS.SELECT"
        :key="column.key"
        class="Fuell-Table--item"
        :class="hideOnLowerRes"
      >
        <input-checkbox
          :id="`input-check-${transaction.id || transaction.user_id}`"
          :value="transactionSelected"
          @click="manageSelectTransaction"
          :disabled="!canReviewTransaction && !isExportTable"
          :class="hideOnLowerRes"
        />
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.STATUS"
        :key="column.key"
        class="Fuell-Table--item clickable"
        @click="emitTransaction"
      >
        <div
          class="transaction-status"
          :class="transactionStatusLabelClass"
        >
          <span v-tooltip="transactionStatusTooltip">
            {{transactionStatusLabel}}
            <img
              v-if="transactionIsProcessing"
              :src="require('@/assets/img/icons/icon-watch.svg')"
              class="pending-icon"
              alt="icon-processing-transaction"
            />
          </span>
        </div>
      </div>
      <div
        v-if="column.key === COLUMNS.WARNING"
        :key="column.key"
        class="Fuell-Table--item clickable"
      >
        <img
          v-if="transactionHasAdvise && showWarnings"
          v-tooltip="transactionAdviseTooltipLabel"
          :src="require(`@/assets/img/icons/icon-warning.svg`)"
          class="transaction-warning-icon"
          alt="transaction-warning-icon"
        />
      </div>
      <div
        v-if="column.key === COLUMNS.LOCK"
        :key="column.key"
        class="Fuell-Table--item clickable"
      >
        <img
          class="transaction-locked-icon"
          alt="transaction-locked-icon"
          v-tooltip="transactionLockedByTooltipLabel"
          v-if="transactionIsLocked"
          :src="require(`@/assets/img/icons/${transactionIsLockedIcon}.svg`)"
        />

      </div>
      <div
        v-if="column.visible && (column.key === COLUMNS.DATE || column.key === COLUMNS.CREATION_DATE)"
        :key="column.key"
        :class="{ pending: transactionIsPending }"
        class="Fuell-Table--item clickable transaction-date"
        @click="emitTransaction"
      >
        {{ transactionDate | formatTheDate('short') }}
        <img
          v-if="transactionIsPending"
          v-tooltip="$t('transactions_status_processing')"
          :src="require('@/assets/img/icons/icon-watch.svg')"
          class="pending-icon"
          alt="icon-transaction-pending"
        />
      </div>
      <div
      class="Fuell-Table--item clickable transaction-date"
      @click="emitTransaction"
      :class="{ pending : transactionIsPending }"
      :key="column.key"
      v-if="column.visible && (column.key === COLUMNS.REVIEWED_DATE)"
      >
      {{ transactionReviewed | formatTheDate('short')}}
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.USER"
        :key="column.key"
        v-tooltip="transactionUserNameAndLastName"
        class="Fuell-Table--item clickable"
        @click="emitTransaction"
      >
        <div class="flex dark">
          <user-name-badge
            :userName="transactionUserNameAndLastName"
            :userAvatarId="transactionUserProfilePictureId"
          ></user-name-badge>
          <span
            class="ellipsis"
            :class="{ pending: transactionIsPending }"
          >{{ transactionUserNameAndLastName }}</span>
        </div>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.EXPENSE_DATE"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="expenseDate"
        @click="emitTransaction"
      >
        <span>
          {{expenseDate}}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.PROCESSING_TRANSACTIONS"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        @click="emitTransaction"
      >
        <div class="flex dark">
          <span>{{ transaction.processing_transactions }}</span>
        </div>
      </div>

      <div
        v-if="column.visible && column.key === COLUMNS.TOTAL"
        :key="column.key"
        v-tooltip="transaction.total_transactions"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        @click="emitTransaction"
      >
        {{ transaction.total_transactions }}
      </div>

      <div
        v-if="column.visible && column.key === COLUMNS.MERCHANT"
        :key="column.key"
        v-tooltip="transactionMerchant"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        @click="emitTransaction"
      >
        <div class="flex">
          <user-name-badge
            v-if="!transactionIsDeclined"
            :userName="transactionMerchant"
            :userAvatarId="transactionMerchantLogo"
            :backgroundClass="transactionMerchantClass"
          />
          <div
            v-else
            class="declined-badge"
          >
            <img
              class="declined-icon"
              :src="require('@/assets/img/icons/declined-icon.svg')"
              alt="Declined"
            />
          </div>
          <span
            class="ellipsis"
            v-if="transactionMerchant"
          >{{ transactionMerchant }}</span>
          <span
            class="ellipsis"
            v-else
          >{{'-'}}</span>
        </div>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.AMOUNT"
        :key="column.key"
        class="Fuell-Table--item clickable dark amount"
        :class="{
        pending: transactionIsPending,
        declined: transactionIsDeclined,
        refund: transactionIsRefund
      }"
        @click="emitTransaction"
      >
        {{
        transactionAmmount
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
      </div>

      <div
        v-if="column.visible && column.key === COLUMNS.CARD"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="transactionPaymentMethod"
        @click="emitTransaction"
      >
        <span> {{transactionPaymentMethod}}</span>
      </div>
      <div
        class="Fuell-Table--item clickable"
        v-tooltip="`${transactionCategory}`"
        v-if="column.visible && column.key === COLUMNS.CATEGORY"
        :key="column.key"
        :class="{ pending: transactionIsPending }"
        @click="emitTransaction"
      >
        <span class="ellipsis">
          {{transactionCategory}}
        </span>
      </div>
      <div
        class="Fuell-Table--item clickable"
        v-tooltip="`${transactionSubCategory}`"
        v-if="column.visible && column.key === COLUMNS.SUBCATEGORY"
        :key="column.key"
        :class="{ pending: transactionIsPending }"
        @click="emitTransaction"
      >
        <span class="ellipsis">
          {{transactionSubCategory}}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.REIMBURSABLE"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="`${transaction.repayable_transactions}`"
        @click="emitRefundableTransactions"
      >
        <span>
          {{ transaction.repayable_transactions }}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.NOT_REIMBURSABLE"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="`${transaction.not_repayable_transactions}`"
        @click="emitNotRefundableTransactions"
      >
        <span>
          {{ transaction.not_repayable_transactions }}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.RECEIPT_NUMBER"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="`${transaction.receipt.receiptNumber}`"
        @click="emitTransaction"
      >
        <span>
          {{ transaction.receipt.receiptNumber }}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.RECEIPT_PROVIDER"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="`${transaction.receipt.provider}`"
        @click="emitTransaction"
      >
        <span>
          {{ transaction.receipt.provider }}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.RECEIPT_PROVIDER_DATA"
        :key="column.key"
        class="Fuell-Table--item clickable"
        :class="{ pending: transactionIsPending }"
        v-tooltip="`${transaction.receipt.providerData}`"
        @click="emitTransaction"
      >
        <span>
          {{ transaction.receipt.providerData }}
        </span>
      </div>

      <div
        v-if="column.visible && column.key === COLUMNS.BUDGET"
        :key="column.key"
        :class="{ pending: transactionIsPending }"
        class="Fuell-Table--item"
        @click="emitTransaction"
      >
        <div
          class="ellipsis"
          v-tooltip="transactionBudgetName"
        >
          {{ transactionBudgetName }}
        </div>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.RECEIPT"
        :key="column.key"
        class="Fuell-Table--item"
        @click.stop
      >
        <template v-if="transactionReceipt && transactionReceipt.receiptMedia && transactionReceipt.receiptMedia.length > 0">
          <button
            @click="emitShowReceiptModal"
            class="Fuell-IconButton Fuell-IconButton--no-margin clickable"
          >
            <img
              :src="transactionReceiptIcon"
              alt="receipts"
              v-tooltip="asyncImage"
            />
          </button>
        </template>
        <template v-else-if="transactionWithoutReceipt">
          <img
            :src="require('@/assets/img/icons/icon-without-receipt.svg')"
            alt="receipts"
          />
        </template>
      </div>

      <div
        v-if="column.visible && column.key === COLUMNS.OPTIONS"
        :key="column.key"
        class="Fuell-Table--item Fuell-Table--options Fuell-Dropdown--button-dots"
      >
        <button
          v-if="!transactionIsDeclined && !transactionIsAuthorization"
          @click="emitTransaction"
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--fixed-width dots"
        >
          <img
            :src="require(`@/assets/img/icons/icon-dots.svg`)"
            alt="options"
          />
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { COLUMNS } from '@/modules/transactions/_constants/Columns'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import _transactionsTableRowInfo from '../../_mixins/_transactionsTableRowInfo'
import _transactionStatusHandlerMixin from '../../_mixins/_transactionStatusHandlerMixin'
import _mediaResourceHandlerMixin from '@/components/Commons/_mixins/_mediaResourceHandlerMixin'

import { segmentTrack } from '@/analytics/segment'

export default {
  name: 'TransactionsTableRow',
  props: {
    transaction: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    isExportTable: {
      type: Boolean,
      default: false
    }

  },
  mixins: [
    _transactionsTableRowInfo,
    _transactionStatusHandlerMixin,
    _mediaResourceHandlerMixin
  ],
  data () {
    return {
      isSubmitting: false,
      transactionSelected: false
    }
  },
  computed: {
    COLUMNS () {
      return COLUMNS
    },
    transactionCategory () {
      if (this.transaction?.defaultCategoryOffice?.name) return this.transaction.defaultCategoryOffice.name
      else if (this.transaction?.expense?.mileage?.mileageCategory?.name) return this.transaction.expense.mileage.mileageCategory.name
      else if (this.transaction?.expense?.diet?.dietCategoryConfigs[0]?.dietCategory?.name) return this.transaction.expense.diet.dietCategoryConfigs[0].dietCategory.name
      return ''
    },
    transactionSubCategory () {
      if (this.transaction?.customCategory?.name) return this.transaction.customCategory.name
      return ''
    },
    mileageCategories () {
      return this.$store.getters['CompanyStore/mileageCategories']
    },
    dietCategories () {
      return this.$store.getters['CompanyStore/dietCategories']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    tableGridTemplateStyle () {
      let columns = this.columns.filter(c => c.visible).map(c => c.template)

      if (!this.showSelect) {
        columns.shift()
      }

      return {
        gridTemplateColumns: columns.join(' ')
      }
    },
    userIsOwnerOfBudget () {
      return !!(this.transaction.budget && this.transaction.budget.imOwner)
    },

    canReviewTransaction () {
      if (this.reviewStatus === 'DRAFT' || this.transactionIsProcessing) {
        return false
      }

      if (this.isUser && this.userIsOwnerOfBudget) {
        return true
      }
      if (this.isAdmin || this.isBookKeeper) {
        return true
      }

      return false
    },
    transactionIsProcessing () {
      return this.transaction.processing
    },
    reviewStatus () {
      return this.transaction && this.transaction.reviewStatus ? this.transaction.reviewStatus.code : false
    },
    expenseDate () {
      if (this.transaction?.expense?.date) {
        return this.$moment.utc(this.transaction.expense.date).format('DD/MM/YY')
      }
      return ''
    }
  },
  methods: {
    hideOnLowerRes () {
      if (window.matchMedia('(max-width:576px)').matches) {
        return 'd-none'
      }
    },
    manageSelectTransaction () {
      if (this.$route.meta.users) {
        this.toggleUser()
      } else {
        this.toggleTransaction()
      }
    },
    toggleUser () {
      this.$store.dispatch('TransactionsStore/toggleSelectedUser', {
        ...this.transaction
      })
    },
    toggleTransaction () {
      this.$store.dispatch('TransactionsStore/toggleSelectedTransaction', {
        ...this.transaction
      })
    },
    emitPendingTransactions () {
      this.$emit('emitPendingTransactions', this.transaction.user_id)
    },
    emitRefundableTransactions () {
      this.$emit('emitRefundableTransactions', this.transaction.user_id)
    },
    emitNotRefundableTransactions () {
      this.$emit('emitNotRefundableTransactions', this.transaction.user_id)
    },
    emitTransaction () {
      if (this.$route.meta.users) {
        this.emitPendingTransactions()
        return
      }
      if (
        this.transaction.status.code === 'KO' ||
        this.transactionIsAuthorization
      ) {
        return
      }

      if (this.transactionType === 'EXPENSE') {
        this.emitExpenseModalHandler()
        return
      }
      this.$emit('showTransactionModal', this.transaction)
    },
    emitExpenseModalHandler () {
      let type = 'expense'
      if (this.isMileage) {
        type = 'mileage'
      }
      if (this.isDiet) {
        type = 'diet'
      }
      this.$emit('showTransactionModal', this.transaction, type)
    },
    emitShowReceiptModal () {
      this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', 'NONE')
      this.$store.dispatch('TransactionsStore/setCurrentTransaction', this.transaction)
      this.$emit('showReceiptModal', { transactionId: this.transaction.id })
    },
    getBudgetsForAmount (amount) {
      return this.budgets
        .map(budget => {
          const budgetOption = { ...budget.budget }
          const availableFunds = budget.available
          if (
            availableFunds < Math.abs(amount) &&
            this.transaction.budget.id !== budget.budget.id
          ) {
            budgetOption.$isDisabled = true
            budgetOption.name += ` - ${this.$t(
              'transactions_budget_not_funds_enough'
            )}`
          } else {
            budgetOption.$isDisabled = false
          }
          return budgetOption
        })
        .sort((a, b) => a.$isDisabled - b.$isDisabled)
    },
    async setTransactionBudget (event) {
      let budget = {
        id: Number.parseInt(event)
      }
      await this.$store.dispatch('TransactionsStore/editTransaction', {
        transactionInformation: {
          id: this.transaction.id,
          budget: budget
        }
      })
      this.$emit('budgetUpdated')
    },
    async submitReceipts (files) {
      this.isSubmitting = true
      await this.$store.dispatch('TransactionsStore/submitTransactionReceipt', {
        id: this.transaction.id,
        files: files
      })

      await this.$store.dispatch(
        'TransactionsStore/fetchTransaction',
        this.transaction.id
      )
      segmentTrack('Transaction ticket added', {
        picture_count: this.transaction.receipt.receiptMedia.length,
        ticket_added: files.length,
        transaction_id: this.transaction.id
      })
      this.isSubmitting = false
    }

  },
  components: {
    UserNameBadge,
    InputCheckbox
  },
  watch: {
    isSelected: function (newV, oldV) {
      this.transactionSelected = newV
    },
    'transaction.isCompleted': function (newV, oldV) {
      const expenses = this.transaction.type.code === 'EXPENSE'
      this.$store.dispatch('TransactionsStore/fetchTransactionDashboard', expenses)
    }
  },
  created () {
    this.transactionSelected = this.isSelected
  }
}
</script>

<style scoped src="@/assets/styles/multiselect/table.css"></style>

<style lang="scss" scoped>
.no-event .clickable {
  cursor: default;
}
.spinner-loading >>> .py-4 {
  height: 24px;
  width: 24px;
  line-height: 24px;
  padding: 0px !important;
}
.pending {
  color: var(--gray);
  opacity: 0.72;
}
.refund {
  color: var(--semantic-positive-main);
}
.transaction-date .pending-icon {
  position: relative;
  left: 2px;
  top: -6px;
}
.declined {
  color: var(--red);
  text-decoration: line-through;
}
.declined-icon {
  width: 20px;
  height: 20px;
}
.declined-badge {
  margin-right: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.02);
}
.amount {
  font-weight: 300;
}
.transaction-status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .pending-icon {
    position: relative;
    right: 0px;
    top: -6px;
    width: 10px;
    height: 10px;
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.transaction-locked-icon {
  width: 16px;
  height: 16px;
  margin-left: auto;
  margin-right: 5px;
}
</style>

<style>
.budgets_select .multiselect__option--disabled {
  background-color: white !important;
  color: var(--gray);
}
.image-big {
  display: block;
  width: 194px;
  height: 270px;
  border-radius: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
